// src/pages/Users/Lexique/components/LexiqueSkeleton.jsx

import React from "react";

export default function LexiqueSkeleton() {
  return (
    <div className="rounded-[1.5rem] border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="h-3 w-24 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
      <div className="mt-3 h-6 w-2/3 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />

      <div className="mt-4 rounded-2xl bg-slate-50 p-3 dark:bg-slate-950">
        <div className="h-3 w-28 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
        <div className="mt-3 h-4 w-4/5 animate-pulse rounded-full bg-slate-200 dark:bg-slate-800" />
      </div>

      <div className="mt-4 grid grid-cols-3 gap-2">
        <div className="h-10 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
        <div className="h-10 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
        <div className="h-10 animate-pulse rounded-2xl bg-slate-200 dark:bg-slate-800" />
      </div>
    </div>
  );
}